import { defineMessages } from '@alltrails/shared/react-intl';

const PRESS_PAGE_STRINGS = defineMessages({
  HERO_SUBHEADER_TEXT: {
    defaultMessage: 'The most trusted outdoor platform in the world'
  },
  HERO_HEADER_TEXT: {
    defaultMessage: 'AllTrails in the news'
  },
  HERO_ALT: {
    defaultMessage: 'Two people hiking near a waterfall while holding hands'
  }
});

enum PressNavId {
  About = 'press-page-about',
  Leadership = 'press-page-leadership',
  Highlights = 'press-page-highlights',
  News = 'press-page-news',
  Kit = 'press-page-kit',
  ContactUs = 'contact-us'
}

export { PRESS_PAGE_STRINGS, PressNavId };
